import { Icon } from '@/Atomic/Atoms/Icon'

export enum ToastMessageType {
  ERROR = 'ERROR',
  SUCCESS = 'SUCCESS',
}

export const ToastColor = {
  [ToastMessageType.ERROR]: 'red',
  [ToastMessageType.SUCCESS]: 'green',
}

export const ToastIcon = {
  [ToastMessageType.ERROR]: (
    <Icon icon="alert-circle" color="danger" className="me-2" />
  ),
  [ToastMessageType.SUCCESS]: null,
}
